import {store} from "./store";

export const useDiscountFirstOrderModal = store;
